// FLAG:useDocuAi — isolated retry banner so its clock hook is unconditional inside this component,
// while the state selector remains unreachable when the feature is OFF.
import React from 'react'

import lang from '@/lang'
import { DocumentAnalysisService } from '@/modules/document/services/documentAnalysis'
import { useAnalysisBlinkCap } from '@/modules/document/utils/use-analysis-blink-cap'
import { isDocumentDrawerAiRetrying } from './document-drawer-ai-state'

type RetryingDocument = Record<string, unknown> & {
  metaData?: {
    ocr?: { isRunning?: boolean }
    analysisRetrying?: {
      at?: string
      attempt?: number
      maxAttempts?: number
      nextRetryAt?: string
    }
  }
}

type DocumentDrawerRetryingBannerProps = {
  enabled: boolean
  document: RetryingDocument
  className: string
  buttonClassName: string
}

const DocumentDrawerRetryingBanner = ({
  enabled,
  document,
  className,
  buttonClassName,
}: DocumentDrawerRetryingBannerProps) => {
  const isRetrying = isDocumentDrawerAiRetrying(enabled, document)
  useAnalysisBlinkCap(isRetrying)

  if (!isRetrying) return null

  return (
    <div className={className}>
      <span>{lang.documents.invoiceAnalysisRetryingTooltip(document.metaData?.analysisRetrying)}</span>
      <button
        type='button'
        className={buttonClassName}
        onClick={() => DocumentAnalysisService.retryNow()}
      >
        {lang.documents.invoiceAnalysisRetryNow}
      </button>
    </div>
  )
}

export default DocumentDrawerRetryingBanner
